import React from 'react';
const ED_LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/jsVUN2DwBFv92UZiHdtkVR/image.png';
export function EDLogo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-136">
      <div className="relative flex items-center justify-center w-10 h-10 bg-ed-black border border-ed-green/50 rounded-lg shadow-[0_0_18px_4px_rgba(163,255,18,0.45),0_0_40px_10px_rgba(163,255,18,0.25)] overflow-hidden p-1" data-id="element-137">
        <img src={ED_LOGO_SRC} alt="ED — Academia de Electricidad Domiciliaria" className="w-full h-full object-contain object-center select-none pointer-events-none" data-id="element-138" />
      </div>
      <div className="flex flex-col" data-id="element-139">
        <span className="text-white font-bold text-sm leading-none tracking-wide" data-id="element-140">
          ACADEMIA DE
        </span>
        <span className="text-zinc-400 text-[10px] uppercase tracking-wider font-medium mt-0.5" data-id="element-141">
          Electricidad Domiciliaria
        </span>
      </div>
    </div>;
}